<template>
<div>
  <div class="main_container">
    <div class="goodslist1">
      <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
    </div>
    <el-form class="findform">
      <el-form-item label="内容类型：" style="display:flex;width:25%;">
        <el-select v-model="contentType" filterable placeholder="请选择" style="width:90%">
          <el-option :label="'全部'" :value="''"/>
          <el-option v-for="(item,index) in nrModeArr" :key="index" :label="item.Name" :value="item.Id"/>
        </el-select>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit()" style="margin: 0 10px;">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="showadd()">新增</el-button> </el-form-item>
    </el-form>
  </div>
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">店铺视图</p>
    </section>
    <div class="table_container">
      <el-table :data="resultObjInfo" stripe border>
        <el-table-column type="selection" align="center"/>
        <el-table-column label="序号" align="center" width="100">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="内容类型" width='150' align="center">
          <template scope="scope">
            <span v-if="scope.row.type == 1">图片</span>
            <span v-if="scope.row.type == 2">视频</span>
            <span v-else></span>
          </template>
        </el-table-column>

        <el-table-column label="内容" width="150" align="center">
          <template scope="scope">
            <!-- <div style="height:36px;" class="banner_list" v-for="(link, i) in scope.row.links" :key="i" v-show="scope.row.type == 1">
              <img :src="baseOssUrl + link" style="width:100%;height:100%" :data-img='baseOssUrl + link' @click="seebigimg(scope.row.links)"  />
            </div> -->
            <div style="height:36px;" class="banner_list" v-show="scope.row.type == 1">
              <span @click="seebigimg(scope.row.links)" style="color:#0099FF">预览</span>
            </div>

            <div style="height:36px;" class="banner_list" v-show="scope.row.type == 2">
              <span @click="palySeevideo(scope.row.links)" style="color:#0099FF">预览</span>
            </div>

          </template>
        </el-table-column>

        <el-table-column align="center" width label="描述">
          <template scope="scope"> <span>{{scope.row.desc}}</span></template>
        </el-table-column>
        <el-table-column label="添加时间" width align="center">
          <template scope="scope"><span>{{scope.row.cTime}}</span></template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right" align="center" width="180px">
          <template scope="scope">
            <span style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="editView(scope.row)" >
              <i class="el-icon-edit-outline"></i> 编辑
            </span>
            <span style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="deleteShopPage(scope.row)" >
              <i class="el-icon-delete"></i> 删除
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>
  <!-- 新增 弹框 -->
  <el-dialog :title="shopTitle" :visible.sync="dialogVisible" width="50%">
    <div style="height: 400px;">
      <el-form style="margin-top:30px; " label-width="170px" >
        <el-form-item label="类型：" :rules="[{ required: true}]" prop>
          <el-radio-group v-model="viewType">
            <el-radio :label=1 >图片</el-radio>
            <el-radio :label=2 >视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="描述：">
          <el-input v-model="viewDesc" auto-complete="off" maxlength="20"
          style="width:560px" placeholder="请输入内容描述最多20个字符"/>
        </el-form-item>
        <el-form-item label="上传：" :rules="[{ required: true}]" prop v-show="viewType == 1">
          <div class="upload" style="display: flex;">
            <div v-for="(link, i) in imgarr" :key="i" style="display:inline; margin-right: 10px">
              <div style="display: inline-block; position: relative;" >
                <img @click="deleteimg(i,link)" src="../../assets/img/aicon36.png" class="chahao"/>
                <el-image v-if="link" :src="link.indexOf(baseOssUrl) !=-1?link:baseOssUrl+link" fit="cover"
                style="width:80px;height:80px"/>
                <i v-else class="el-icon-plus avatar-uploader-icon" style="width:80px;"></i>
              </div>
            </div>
            <div class="upload" style="display:inline;" v-show="isdisabled">
              <el-upload :disabled="!isdisabled" style action :show-file-list="false"
                class="avatar-uploader" :before-upload="beforeAvatarUpload">
                <img style="width:80px;height:80px" v-if="imageUrl2" :src="imageUrl2"/>
                <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 80px;"></i>
              </el-upload>
            </div>
          </div>
          <span style="text-align:center;color:#ff8083;vertical-align: bottom;">最多上传5张 (支持JPG  PNG 格式)，单张图片大小不超过5MB</span>
        </el-form-item>

        <el-form-item label="视频：" :rules="[{ required: true}]" prop v-show="viewType == 2">
          <div v-if="videoSrc" class="videoClass">
            <span @click="newSeevideo()" class="previewingVideo">
              <img :src="videoImg" v-if="videoImg">
              <img src="../../assets/img/spfm.png" v-else>
              <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
            </span>
            <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
          </div>
          <el-upload v-else class="avatar-uploader-zstp" action="" accept="video/*" :before-upload="handleFile">
            <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footSuspension">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="endAdd()" :loading="loadingBut">{{loadingButText}}</el-button>
      </div>
    </div>
  </el-dialog>
    
  <div class="fullscreenMask" v-if="isShowImageDialog" @click="clearImg">
    <i class="el-icon-circle-close" style="position: absolute ;top: 50px;right: 50px;font-size: 30px;cursor: pointer;"/>
    <div style="width: 800px;margin: 200px 0 0 30%;">
      <el-carousel :autoplay = "false" height="500px">
        <el-carousel-item v-for="(item,index) in ShowImageDialogImgarr" :key="index" style="display: flex;align-items: center;justify-content: center;">
          <img :src="baseOssUrl + ShowImageDialogImgarr[index]" style="max-width: 100%; max-height: 100%;"/>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>

  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" width="30%" @close="closeVideo" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>

  <div style="text-align: center;margin:120px 0 30px 0;">
    <el-button @click="goback()">返 回</el-button>
  </div>
</div>
</template>
<script>
import { uploadOSS } from '../../utils/oss';
import {getOssFile, uploadVedio} from '../../api/newOss';
import { addShopPage, deleteShopPage, getShopPageList,editShopPage } from "../../api/shopWindow";
export default {
  name: "ShopPage",
  data() {
    return {
      loadingBut: false,
      loadingButText: '保 存',
      contentType: "", // 内容类型
      // 内容类型
      nrModeArr: [
        {
          Id: 1,
          Name: "图片"
        },
        {
          Id: 2,
          Name: "视频"
        },
      ],
      resultObjInfo: [], //列表源数据
      pageSize: 10,
      pageIndex: 1,
      total: 10,
      shopTitle: '', // 详情title
      dialogVisible: false, // 详情弹框
      viewId: null, // id
      viewType: 1, // 类型
      viewDesc: '', // 描述
      imageUrl2: "", // 图片
      imgarr:[], // 图片集合
      baseOssUrl: localStorage.BaseOssUrl,
      isShowImageDialog:false, // 查看大图弹框
      ShowImageDialogImgarr:[], // 大图预览
      isdisabled:true, // 置灰禁用

      shortfm:'', // 封面短
      shortsp:'', // 视频短
      videoImg: '', // 视频封面全路径
      videoSrc: '', // 视频相对路径
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          // type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
    };
  },
  methods: {
    // 获取列表数据
    init() {
      var that = this;
      var obj = {
        bbid: localStorage.businessBbId,
        type: that.contentType ==""?0:that.contentType,
        pageIndex: that.pageIndex,
        pageSize: that.pageSize
      };
      getShopPageList(obj).then(data => {
        if(data) {
          if(data.resultCode == 1) {
            that.resultObjInfo = data.resultObj.resultObj
            that.total = data.resultObj.rowsCount
            that.resultMsg = data.resultMsg;
          } else {
            that.resultObjInfo = []
          }
        }else{
          that.resultObjInfo = []
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 删除数据
    deleteShopPage(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = row.id
          deleteShopPage(obj).then((data) => {
            if (data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: "删除成功",
              });
              this.init();
            }
          });
        }
      });
    },
    // 新增
    showadd() {
      if (localStorage.businessBbId == 0) {
        this.$swal({
          type:"warning",
          text:"请前往基础信息管理中添加您代理的品类品牌信息"
        })
        return false;
      }
      this.dialogVisible = true; // 详情弹框
      this.shopTitle = '新增';
      this.viewId = null;
      this.viewType = 1; // 类型
      this.viewDesc = ""; // 描述
      this.imgarr = [];
      this.isdisabled = true;

      this.shortfm = "";
      this.shortsp = "";
      this.videoImg = "";
      this.videoSrc = "";
    },
    // 编辑
    editView(row) {
      this.viewId = row.id;
      this.shortfm = row.coverImg; // 获取封面图
      this.shortsp = row.links[0]; // 获取列表视频路径回显
      
      this.imgarr = [];
      if(row.type == 1){
        for(let i =0; i <row.links.length; i++){
          this.imgarr.push(row.links[i]);
        }
        if (this.imgarr.length >= 5) {
          this.isdisabled = false;
        }else{
          this.isdisabled = true;
        }
        this.shortfm='';
        this.shortsp='';
        this.videoImg = '';
        this.videoSrc = '';
      }
      if(row.type == 2){
        this.videoImg = localStorage.BaseOssUrl + this.shortfm; // 拼接封面图路径
        this.videoSrc = localStorage.BaseOssUrl + this.shortsp; // 拼接视频路径
      }
      this.dialogVisible = true; // 详情弹框
      this.shopTitle = '编辑';
      this.viewType = row.type; // 赋值类型
      this.viewDesc = row.desc; // 赋值描述
    },
    // 保存
    endAdd(){
      if(this.viewType == ""){
        this.$swal({
          type:"warning",
          text:"请选择类型"
        })
        return false;
      }
      if(this.viewType == "1"){
        if(this.imgarr.length <=0){
          this.$swal({
            type:"warning",
            text:"请上传图片"
          })
          return false;
        }
        for(var i = 0; i < this.imgarr.length; i++) {
          this.imgarr[i] = this.imgarr[i].replace( localStorage.BaseOssUrl, '')
        }
      }
      if(this.viewType == "2"&&this.videoSrc == ''){
        this.$swal({
          type:"warning",
          text:"请上传视频"
        })
        return false;
      }
      let obj = {
        userId: localStorage.Id,
        bbid: localStorage.businessBbId,
        id : this.viewId,
        type: this.viewType, // 类型
        desc: this.viewDesc, // 描述
        coverImg : this.shortfm, // 视频封面-短
        links: this.viewType ==1?this.imgarr:[this.shortsp], // 视频-短
      }
      if(this.viewId){
        editShopPage(obj).then(data=>{
          if(data.resultCode == 1){
            this.dialogVisible = false; // 详情弹框
            this.$swal({
              type:"success",
              text:"保存成功"
            })
            this.init();
            this.loadingBut = false;
            this.loadingButText = '保 存';
          }else if(data.resultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          } else {
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          }
        })
      }else{
        addShopPage(obj).then(data=>{
          if(data.resultCode == 1){
            this.dialogVisible = false; // 详情弹框
            this.$swal({
              type:"success",
              text:"保存成功"
            })
            this.init()
            this.loadingBut = false;
            this.loadingButText = '保 存';
          }else if(data.resultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          } else {
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          }
        })
      }
    },
    // 上传图片
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let valid = file.size / 1024 / 1024 < 2;
        valid ? resolve() : reject();
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          // oss 直传图片
          var obj = {type: 29};
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imgarr.push(newOssPic);
          that.FileID = newOssPic.replace(localStorage.BaseOssUrl,'')
        };
        if (that.imgarr.length >= 4) {
          that.isdisabled = false;
        }
      }).catch(() => {
        this.$swal({
          type:"warning",
          text:"上传文件大小不能超过 2MB!"
        })
      });
    },
    // 删除图片
    deleteimg(index) {
      this.imgarr.splice(index, 1);
      // this.FileID.splice(index, 1);
      if (this.imgarr.length >= 5) {
        this.isdisabled = false;
      }else{
        this.isdisabled = true;
      }
    },
    // 预览
    seebigimg(arr){
      this.isShowImageDialog = true;
      this.ShowImageDialogImgarr = arr;
    },
    // 关闭查看大图
    clearImg(){
      this.isShowImageDialog = false;
    },
    // 返回
    goback(){
      this.$router.go(-1);
    },
    // 视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.$swal({
          type:"warning",
          text:"请上传小于50MB的视频"
        })
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.$swal({
          type:"warning",
          text:"请上传mp4格式的视频"
        })
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      // this.videoUploadPercent = Math.floor(file.percentage)
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.shortfm='';
      this.shortsp='';
      this.videoImg = '';
      this.videoSrc = '';
      let obj2 = new FormData();
      // obj2.append('file',event.target.files[0]);
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2, 3).then(data=>{
        if(data.resultCode == 1){
          this.shortfm = data.resultObj.r_png; // 封面 短
          this.shortsp = data.resultObj.r_m3u8; // 视频 短
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8; // 视频全路径
          this.loadingBut = false;
          this.loadingButText = '保存';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      });
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.shortsp);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = localStorage.BaseOssUrl + url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.shortfm='';
          this.shortsp='';
          this.videoImg='';
          this.videoSrc='';
          // videoUrl.sources[0].src = ''
          // videoUrl.poster = ''
        }
      }).catch(() => {
        return;
      });
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  font-size: 28px;
  color: #8c939d;
  border: 1px solid #eee;
  text-align: center;
}
/* 新增/编辑橱窗商品 底部操作按钮固定 */
.footSuspension {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-top: 1px solid #eee;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// ShopPage.vue?082f7e4e